module.exports = __webpack_public_path__ + "img/uleague-logo-white.e7dd8cee.svg";